define( function() {
	"use strict";

	return window.document;
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/document.js
// module id = 6
// module chunks = 0